<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-s-tools"></i> GM 相关</el-breadcrumb-item>
                <el-breadcrumb-item>{{ postOrUpdate.content }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <el-page-header @back="goBack" :content="postOrUpdate.content"></el-page-header>
            <el-divider></el-divider>

            <div style="margin-bottom: 15px; width: 70%;">
                <div class="plugins-tips">
                    <el-radio v-model="radio" label="0" :disabled="postOrUpdate.flag">全体用户</el-radio>
                    <el-radio v-model="radio" label="1" @change="SpecifyUserChange()" :disabled="postOrUpdate.flag">指定用户</el-radio>
                </div>
                <div v-show="radio == 1 && postOrUpdate.flag == false">
                    <el-table
                    ref="multipleTable"
                    :data="user.tableData"
                    :header-cell-style="{'text-align':'center'}"
                    :cell-style="{'text-align':'center'}"
                    max-height="300"
                    stripe
                    >
                        <el-table-column prop="userId" label="ID"></el-table-column>
                        <el-table-column prop="platformId" label="平台Id"></el-table-column>
                        <el-table-column prop="nickName" label="昵称"></el-table-column>
                        <el-table-column width="55" label="">
                            <template slot="header" slot-scope="scope">
                                <!-- 弹框, 添加指定用户-->
                                <el-popover
                                    :ref="scope"
                                    placement="right-start"
                                    width="500"
                                    trigger="click"
                                    >
                                    <el-table 
                                        :data="user.toBeTableData" 
                                        height="537"
                                        v-loading="user.loading"
                                        stripe
                                        >
                                        <el-table-column prop="userId" label="用户名">
                                            <template slot="header" slot-scope="scope">
                                                <el-input
                                                    :slot="scope"
                                                    @keyup.enter.native="SpecifyUserChange"
                                                    v-model.trim="userIdSearch"
                                                    size="mini"
                                                    placeholder="回车搜索"
                                                />
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="platformId" label="平台Id"></el-table-column>
                                        <el-table-column prop="nickName" label="昵称"></el-table-column>
                                        <el-table-column width="68" label="">
                                            <template style="cursor: pointer;" slot-scope="scope">
                                                <div style="cursor: pointer; width: 100%">
                                                    <el-button @click="addUsers(scope.row)">添加</el-button>
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="pagination">
                                        <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleUserPageChange"
                                        :current-page="user.pageIndex"
                                        :page-size="user.pageSize"
                                        :total="user.pageTotal"
                                        layout="prev, pager, next, jumper"
                                        background
                                        ></el-pagination>
                                    </div>
                                    <el-button type="text" slot="reference" style="font-size: 25px; cursor: pointer; color: #606266; padding: 0;">   
                                        <i class="el-icon-circle-plus-outline" style="cursor: pointer;"/>
                                    </el-button>
                                </el-popover>
                            </template>
                            
                            <template style="cursor: pointer;" slot-scope="scope">
                                <div style="cursor: pointer; width: 100%" @click="deleteUser(scope.row)">
                                    <i class="el-icon-delete" style="font-size: 15px; cursor: pointer;"></i>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <div style="border: 1px solid #ccc; border-radius: 6px ; width: 70%;">
                <el-form :model="form" :rules="rules" ref="emaileForm" label-width="0px" class="ms-content">
                    <el-form-item prop="title">
                        <el-input placeholder="请输入标题" v-model="form.title" :disabled="postOrUpdate.flag">
                            <template slot="prepend">邮件标题</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="content">
                        <el-input
                            :disabled="postOrUpdate.flag"
                            :rows="28"
                            type="textarea"
                            placeholder="请输入内容"
                            v-model="form.content"
                            style="margin-top: 15px">
                        </el-input>
                    </el-form-item>
                    <div class="register-btn">
                        <el-button type="primary" @click="onSubmit('emaileForm')" style="margin-left: 85%; margin-bottom: 10px" v-show="!postOrUpdate.flag"> 提交邮件</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    
</template>

<script>
import { getNormalUser, postEmail, getEmailById } from '../../api/gameconsole-mars.js'
export default {
    name: 'Email',
    data: function(){
        return {
            //动态路由 参数
            id: undefined, 
            //标识新增 还是 修改
            postOrUpdate: {
                title: '提交公告',
                content : '新增公告',
                flag: false,  //是否隐藏 提交按钮 是否禁用 全体用户和指定用户按钮
            },

            radio: '0', //0: 全体用户, 1: 指定用户

            user: {
                tableData: [],     //已添加用户
                toBeTableData: [], //可添加用户
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: false,

                username: ''
            },

            form: {
                title: '',   //标题
                content: ''  //内容
            },
            html: '',  // 展示框内容
            userIdSearch: '',  //搜索

            //表单验证
            rules: {
                title: [
                    { required: true, message: '标题不能为空', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '内容不能为空', trigger: 'blur' },
                ],
            },
        }
    },
    mounted() {
        //如果 传值了id，就调用 邮件详细 函数， 否则 新增邮件
        this.id = localStorage.getItem('emailId')
        this.initData()
    },
    activated() {
        let id = localStorage.getItem('emailId')
        //如果 传值了id，就调用 邮件详细 函数， 否则 新增邮件
        if (id != undefined && id != 'undefined') {
            this.postOrUpdate.content = '邮件详细'  //将 新增邮件 替换成 邮件详细
            this.postOrUpdate.flag = true        //隐藏 提交按钮 禁用全体和指定单选框
            this.id = id
            this.initData()
        } else {
            this.postOrUpdate.content = '新增邮件'  //将 新增邮件 替换成 邮件详细
            this.postOrUpdate.flag = false        //显示 提交按钮  解禁全体和指定单选框
            this.radio = '0'
        }

        //清空缓存
        this.form.title = ''
        this.form.content = ''
        this.user.tableData = []
    },
    methods: {
        //如果动态路由有参数, 初始化页面
        initData() {
            let params = {'id': this.id}
            getEmailById(params).then(res => {
                if (res.data.code == 200) {
                    this.form.content = res.data.data.content
                    this.form.title = res.data.data.title
                    this.radio = ''+ res.data.data.emailCond + ''
                }
            })
        },

        //指定用户 - 获取用户表格数据
        SpecifyUserChange(){
            this.user.loading = true
            let params = {'id': this.userIdSearch, 'pageIndex': this.user.pageIndex, 'pageSize': this.user.pageSize }
            getNormalUser(params).then(res => {
                if(res.data.code == 200) {
                    this.user.toBeTableData = res.data.data.records
                    this.user.pageTotal = res.data.data.total

                    //移除已被添加的用户数据
                    this.user.tableData.forEach(item => {
                        //移除已经添加过去的数据
                        this.user.toBeTableData = this.user.toBeTableData.filter(jtem => {
                            return item.userId !== jtem.userId
                        })
                    })
                }

            }).finally(err => {
                this.user.loading = false
            })
        },

        //提交按钮
        onSubmit(emaileForm) {
            this.$refs[emaileForm].validate((valid) => {
                if (valid) {
                    let userId = localStorage.getItem('userId')         //编辑者Id
                    let params = {'creatorId': userId, 'title': this.form.title, 'content': this.form.content, 'emailShow': 0 , 'emailCond': this.radio}

                    //radio   0: 全体用户, 1: 指定用户. 如果为 1, 参数加上用户Id集合
                    if (this.radio == 1) {
                        params = {'creatorId': userId, 'title': this.form.title, 'content': this.form.content, 'emailShow': 0 , 'emailCond': this.radio, 'userIdList': this.user.tableData}
                    }

                    //发送请求     
                    postEmail(params).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message)
                            this.$router.push('/Gameconsole')
                        }
                    })
                }
            })
        },

        //上一页 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.SpecifyUserChange()
        },
        //手动输入页码
        handleSizeChange(pageIndex){
            this.user.pageIndex = pageIndex
            this.SpecifyUserChange()
        },

        //从 可添加用户Table 添加到 已添加用户Table
        addUsers(user) {
            //添加到 已添加用户Table
            this.user.tableData.push({'userId': user.userId, 'platformId': user.platformId, 'nickName': user.nickName})

            //移除已经添加过去的数据
            this.user.toBeTableData = this.user.toBeTableData.filter(item => {
                return item.userId !== user.userId
            })
        },

        //删除 已添加用户Table 数据
        deleteUser(user) {
            //添加到 可添加用户Table
            this.user.toBeTableData.push({'userId': user.userId, 'platformId': user.platformId, 'nickName': user.nickName})

            //移除已经添加过去的数据
            this.user.tableData = this.user.tableData.filter(item => {
                return item.userId !== user.userId
            })
        },

        //返回上一页
        goBack() {
            this.$router.push('/Gameconsole')
        },
    }
}
</script>

<style scoped lang="scss">

</style>